import { toast } from 'react-toastify';
function toastError(message, timeout) {
    toast.error(message, {
        position: 'top-center',
        autoClose: timeout ? timeout : false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
        className: 'toast-base toast-error',
    });
}
export default toastError;
